import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { scrollBarStyling } from 'src/styles/styles';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

import { colors } from '../../styles/colors';
import {
  getInitialLoadIcons,
  ZeeFontBold,
  ZeeFontRegular
} from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
import { flex } from '../../styles/utils';

export const navMenuWrapper = css`
  color: ${colors.PrimaryWhiteColor};
  height: 64px;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: left;
  ${flex()};
  overflow-x: auto;
  ${MQ.MediaMd} {
    margin-top: 0;
  }
  ${MQ.MediaLg} {
    height: 46px;
  }
  ul {
    margin: 0;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    height: 100%;
    padding: 0;
    > li {
      list-style-type: none;
      white-space: nowrap;
      > a {
        position: relative;
        &:after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          width: 0;
          bottom: -8px;
          height: 2px;
          background: ${colors.PrimaryWhiteColor};
          opacity: 0;
          margin: auto;
          transition: width 0.25s ease-in,
            bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
            opacity 0.25s ease-in,
            bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
        }
      }
    }
  }
  ${MQ.MobilePortrait} {
    display: -webkit-box;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  ${MQ.MediaLg} {
    overflow-x: initial;
  }
`;

export const moreMenuIcon = css`
  padding: 15px 18px 32px 18px;
  margin-top: auto;
  > ul {
    display: none;
  }
  &:hover {
    > ul {
      padding: 16px 0px;
      display: block;
      position: absolute;
      height: auto;
      background: ${colors.AppBgColor};
      border: 1px solid ${colors.PrimaryWhiteColorAlpha11};
      border-radius: 6px;
      box-shadow: 0 2px 4px 0 ${colors.black};
      margin-top: 32px;
      transform: translateX(-50%);
      max-height: calc(100vh - 100px);
      overflow: hidden;
      overflow-y: auto;
      ${scrollBarStyling(
        '5px',
        colors.AccentDarkGrayColor,
        colors.ComboPopupSubtitleGray
      )};
      li {
        border-bottom: 0px solid ${colors.PrimaryWhiteColorAlpha10};
        padding: 1px 16px;
        > a {
          display: block;
          ${ZeeFontBold(14, 22)};
          box-sizing: border-box;
          width: 168px;
          height: 48px;
          padding: 14px 16px;
          border-radius: 8px;
          text-align: left;
          cursor: pointer;
          color: ${colors.NavMenuTextColor};
          &:hover {
            background: ${colors.PrimaryWhiteColorAlpha06};
          }
        }
      }
    }
  }
`;

export const menuItemsWrapper = (
  moreMenu: boolean,
  isChannelPathCorrect: boolean
) => {
  return css`
    left: 0;
    right: 0;
    z-index: 1;
    text-align: left;
    ${flex('row', 'center', 'center')}
    margin: 0;
    list-style-type: none;
    border-radius: 3px;
    padding: 0 18px;
    white-space: nowrap;
    > a {
      position: relative;
      ${MQ.MobileXs} {
        ${ZeeFontRegular(13, 20)};
      }
      ${MQ.MediaSm} {
        ${ZeeFontRegular(14)};
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        width: 0;
        bottom: -8px;
        height: 2px;
        background: ${colors.PrimaryWhiteColor};
        opacity: 0;
        margin: auto;
        transition: width 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          opacity 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
      }
      ${!moreMenu && isChannelPathCorrect
        ? `
        color: ${colors.PrimaryWhiteColor};
        &:after {
          width: 100%;
          opacity: 1;
        }`
        : `
          color: ${colors.PrimaryWhiteColorAlpha90};
          `};
    }
    ${!moreMenu
      ? `
    &:hover{
      >a {
        text-shadow: 0.5px 0 0.5px ${colors.PrimaryWhiteColor};
        position: relative;
        &:after{
          width: 100%;
          opacity: 1;
          transition: width 0.25s ease-in,
            bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
        }
      }
    }`
      : ``}
  `;
};

export const moreMenuStyle = css`
  ${moreMenuIcon};
  ${getInitialLoadIcons(InitialLoadIconsSet.MORE_MENU)};
  cursor: pointer;
  &:hover {
    &:before {
      transition: color 0.25s ease-in,
        bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
      color: ${colors.Lavender};
    }
  }
`;

export const activeItem = css`
  &:after {
    width: 100%;
    opacity: 1;
  }
`;

export const selectedItemStyle = (
  moreMenu: boolean,
  isChannelPathCorrect: boolean
) => css`
  ${moreMenu && isChannelPathCorrect
    ? `background: ${colors.PrimaryWhiteColorAlpha06};`
    : ``}
`;
